// If Needs to import any script:
import { tns } from 'tiny-slider';

export function createAlbumCarrocel(id){
    const classId = '.album-' + id;
    const albumComponente = document.querySelector(classId)

        const albumSlider = tns({
            container: classId + ' .album-slider .wp-block-gallery',
            items: 1,
            slideBy: 'page',
            controls: true,
            nav: false,
            loop: false,
            autoplay: true,
            navPosition: "bottom",
            speed: 600,
            autoplayTimeout: 3000,
            touch: true,
            controlsText: [
                '<svg style="enable-background:new 0 0 91 91;" version="1.1" viewBox="0 0 91 91" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g transform="rotate(180 45.5 45.5)"> <!-- Aplica rotação de 180 graus ao redor do centro do SVG --><path class="st0" d="M36.6,43.5C31.1,49,25.7,54.8,20.7,60.8c-5.1,6.2-12,13.7-12.7,21.9c-0.1,1.3,1.5,2.5,2.7,2   c7.7-3.1,13.1-11.4,18.6-17.4c6.7-7.3,13.6-14.4,20.9-21c2.8-2.5,1.9-7.3-1.2-9.1C36.3,30,27,18.8,19.7,6.2   C15-1.9,2.2,5.6,7.2,13.5C14.8,25.7,24.6,35.8,36.6,43.5z"/><path class="st0" d="M72.9,43.5C67.3,49,62,54.8,57,60.8C52,67.1,45,74.5,44.3,82.7c-0.1,1.3,1.5,2.5,2.7,2   c7.7-3.1,13.1-11.4,18.6-17.4c6.7-7.3,13.6-14.4,20.9-21c2.8-2.5,1.9-7.3-1.2-9.1C72.6,30,63.3,18.8,56,6.2   c-4.7-8.1-17.5-0.6-12.5,7.3C51.1,25.7,60.9,35.8,72.9,43.5z"/></g></svg>',
                '<svg style="enable-background:new 0 0 91 91;" version="1.1" viewBox="0 0 91 91" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path class="st0" d="M36.6,43.5C31.1,49,25.7,54.8,20.7,60.8c-5.1,6.2-12,13.7-12.7,21.9c-0.1,1.3,1.5,2.5,2.7,2   c7.7-3.1,13.1-11.4,18.6-17.4c6.7-7.3,13.6-14.4,20.9-21c2.8-2.5,1.9-7.3-1.2-9.1C36.3,30,27,18.8,19.7,6.2   C15-1.9,2.2,5.6,7.2,13.5C14.8,25.7,24.6,35.8,36.6,43.5z"/><path class="st0" d="M72.9,43.5C67.3,49,62,54.8,57,60.8C52,67.1,45,74.5,44.3,82.7c-0.1,1.3,1.5,2.5,2.7,2   c7.7-3.1,13.1-11.4,18.6-17.4c6.7-7.3,13.6-14.4,20.9-21c2.8-2.5,1.9-7.3-1.2-9.1C72.6,30,63.3,18.8,56,6.2   c-4.7-8.1-17.5-0.6-12.5,7.3C51.1,25.7,60.9,35.8,72.9,43.5z"/></g></svg> '
            ],
        });
        
        albumSlider.pause();
    
        albumComponente.querySelector('.album-slider .wp-block-gallery').classList.remove('has-nested-images')
    
    
        const pageIndicator = albumComponente.querySelector('.album-nav .page-indicator');
    
        function updatePageIndicator(info) {
            const currentIndex = info.displayIndex;
            const totalItems = info.slideCount;
            pageIndicator.textContent = `${currentIndex} / ${totalItems}`;
        }
    
        albumSlider.events.on('indexChanged', (info) => {
            updatePageIndicator(info);
        });
    
        // Initial update of the page indicator
        updatePageIndicator(albumSlider.getInfo());
    
        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                albumSlider.goTo('prev');
                pause();
            } else if (e.key === 'ArrowRight') {
                albumSlider.goTo('next');
                pause();
            }
        });
    
        let galeryControlButtons = albumComponente.querySelectorAll('.album-slider .tns-controls button');
    
        galeryControlButtons.forEach((button) => {
            button.addEventListener('click', ()=>{
                pause();
            })
        });
    
    
        // Autoplay functionality
        let isAutoplaying = false;
        const autoplayButton = albumComponente.querySelector('.autoplay-button');
        const playIcon = albumComponente.querySelector('.play-icon');
        const pauseIcon = albumComponente.querySelector('.pause-icon');
    
        autoplayButton.addEventListener('click', () => {
            if (!isAutoplaying) {
                play();
            } else {
                pause();
            }
        });
    
        function play(){
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
            albumSlider.goTo('next');
            albumSlider.play();
            isAutoplaying = true;
            window.pause = pause;
    
        }
    
        function pause(){
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            albumSlider.pause();
            isAutoplaying = false;
        }
    

}    
